module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/battle//ko.png?v=c7c7fef5";